import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import axiosProtected from "../config/baseWithToken";
import { axiosClient } from "../config/base";

export const addStore = createAsyncThunk(
  "store/add-store",
  async (store, thunkAPI) => {
    try {
      let { data } = await axiosProtected.post("/store", store);
      localStorage.setItem("usend_connected_store", data.store);
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const createAnnouncement = createAsyncThunk(
  "store/create-announcement",
  async (announcement, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.post(
        "/admin/announcements",
        announcement
      );
      dispatch(getAnnouncement());
      toast.success(data.message);
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);

export const updateAnnouncement = createAsyncThunk(
  "store/update-announcement",
  async (announcement, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.put(
        `/admin/announcements/${announcement?.announcementId}`,
        announcement?.updatePayload
      );
      dispatch(getAnnouncement());
      toast.success(data.message);
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);

export const getAnnouncement = createAsyncThunk(
  "store/get-announcement",
  async (_store, thunkAPI) => {
    try {
      let { data } = await axiosProtected.get("/admin/announcements");
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const addStoreByShopifyApp = createAsyncThunk(
  "store/add-store-shopify",
  async (store, thunkAPI) => {
    try {
      let { data } = await axiosClient.post("/store/app/install", store);
      localStorage.setItem("usend_connected_store", data.store);
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const addUser = createAsyncThunk(
  "store/add-user",
  async (user, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.post("/store/user", user);
      dispatch(getUserActiveStores());
      toast.success(data.message);
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);

export const getStores = createAsyncThunk(
  "store/get-stores",
  async (store, thunkAPI) => {
    try {
      let { data } = await axiosProtected.get("/store");
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
    }
  }
);

export const getStoresByUser = createAsyncThunk(
  "admin/stores/users",
  async (_store, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.get("/admin/stores/users");
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);

export const getAllStores = createAsyncThunk(
  "admin/get-stores",
  async (store, thunkAPI) => {
    try {
      let { data } = await axiosProtected.get(
        `/admin/stores?page=${store.page || 0}&size=${50}`
      );
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
    }
  }
);

export const getAllRecordsByUser = createAsyncThunk(
  "admin/get-all-records",
  async (userId, thunkAPI) => {
    try {
      let { data } = await axiosProtected.get(`/admin/users/records/${userId}`);
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
    }
  }
);

export const getAllUsers = createAsyncThunk(
  "admin/get-users",
  async (user, thunkAPI) => {
    try {
      let url = `/admin/users?page=${user.page || 0}&size=${50}`;

      if (user.text) {
        url = url + `&text=${user.text}`;
      }
      if (user.status) {
        url = url + `&status=${user.status}`;
      }
      let { data } = await axiosProtected.get(url);
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
    }
  }
);

export const getTotals = createAsyncThunk(
  "get/admin/totals",
  async (_product, thunkAPI) => {
    try {
      let { data } = await axiosProtected.get(`/admin/products/totals`);
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
export const getTotalsOfCustomerData = createAsyncThunk(
  "get/customer/totals",
  async (_product, thunkAPI) => {
    try {
      let { data } = await axiosProtected.get(`/products/totals`);
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getUserActiveStores = createAsyncThunk(
  "store/get-active-stores",
  async (store, thunkAPI) => {
    try {
      let { data } = await axiosProtected.get("/store/user");
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
    }
  }
);
export const updateStore = createAsyncThunk(
  "admin/store/update-store",
  async (store, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.put(
        `/admin/stores/${store?.storeId}`,
        store?.updatePayload
      );
      if (!store?.new_store) {
        toast.success(data.message);
      }

      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);

export const updateStoreUser = createAsyncThunk(
  "store/update-store-user",
  async (user, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.put(`/store/user/${user.userId}`);
      toast.success(data.message);
      dispatch(getUserActiveStores());
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);

export const updateUserByAdmin = createAsyncThunk(
  "store/update-user-byadmin",
  async (user, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.put(
        `/admin/users/${user.userId}`,
        user.updatePayload
      );
      toast.success(data.message);
      // dispatch(getAllUsers({ page: 0, size: 50 }));
      dispatch(getUserActiveStores());
      dispatch(getTotals());
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);

export const getCurrentStore = createAsyncThunk(
  "store/user/me",
  async (storeId, thunkAPI) => {
    try {
      let { data } = await axiosProtected.post(`/store/user/me`, storeId);

      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const deleteStore = createAsyncThunk(
  "store/delete-store",
  async (storeId, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.delete(`/admin/stores/${storeId}`);
      toast.success(data.message);
      dispatch(getAllStores({ page: 0, size: 50 }));
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);

// export const getReturnedOrdersAndDisputesAnalytics = createAsyncThunk(
//   "store/returned-orders-dispute",
//   async (_storeId, { dispatch, rejectWithValue }) => {
//     try {
//       let { data } = await axiosProtected.get(
//         `/store/dispute-returned-orders-analytics`
//       );
//       return data?.result;
//     } catch (e) {
//       toast.error(e.response.data.message);
//       rejectWithValue(e.response.data);
//     }
//   }
// );
// export const getCogsRevenueAndCurrentBalance = createAsyncThunk(
//   "store/cogs-revenue",
//   async (formattedDate, { dispatch, rejectWithValue }) => {
//     try {
//       let { data } = await axiosProtected.get(
//         `/store/cogs-revenue-balance?date=${moment(formattedDate).format(
//           "YYYY-MM-DD"
//         )}`
//       );
//       return data?.result;
//     } catch (e) {
//       toast.error(e.response.data.message);
//       rejectWithValue(e.response.data);
//     }
//   }
// );
// export const getTop3SellingProducts = createAsyncThunk(
//   "store/top-selling-products",
//   async (formattedDate, { dispatch, rejectWithValue }) => {
//     try {
//       let { data } = await axiosProtected.get(`/store/top-selling-products`);
//       return data?.result;
//     } catch (e) {
//       toast.error(e.response.data.message);
//       rejectWithValue(e.response.data);
//     }
//   }
// );
// export const getRevenue = createAsyncThunk(
//   "store/top-selling-products",
//   async (formattedDate, { dispatch, rejectWithValue }) => {
//     try {
//       let { data } = await axiosProtected.get(
//         `/store/revenue?date=${moment(formattedDate).format("YYYY-MM-DD")}`
//       );
//       return data?.result;
//     } catch (e) {
//       toast.error(e.response.data.message);
//       rejectWithValue(e.response.data);
//     }
//   }
// );
// export const getOrdersStatistics = createAsyncThunk(
//   "store/order-statistics",
//   async (formattedDate, { dispatch, rejectWithValue }) => {
//     try {
//       let { data } = await axiosProtected.get(
//         `/store/orders-statistics?date=${moment(formattedDate).format(
//           "YYYY-MM-DD"
//         )}`
//       );
//       return data?.result;
//     } catch (e) {
//       toast.error(e.response.data.message);
//       rejectWithValue(e.response.data);
//     }
//   }
// );
